import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit/responsive/hooks/useDeviceType';

import { NewReviewModalFooter } from '../../components/NewReviewModal/parts/NewReviewModalFooter';
import { goToNextStep, goToPrevStep } from '../../actions/newReview';
import { selectIsPrevStepAvailable } from '../../selectors/newReview';
import { TThunkDispatch } from '../../types/redux';
import { getNewReviewLoading } from '../../selectors/newReview/getNewReviewLoading';

interface IProps {
  nextButtonText?: string;
  onNextClick?: VoidFunction;
}

export const DailyrentNewReviewModalFooterContainer = ({ nextButtonText, onNextClick }: IProps) => {
  const deviceType = useDeviceType();
  const dispatch = useDispatch<TThunkDispatch>();
  const isPrevStepAvailable = useSelector(selectIsPrevStepAvailable);
  const isLoading = useSelector(getNewReviewLoading);
  const isMobile = deviceType === 'phone';

  const handleNextClick = React.useCallback(() => {
    dispatch(goToNextStep());

    onNextClick?.();
  }, [dispatch]);

  const onPrevClick = () => {
    dispatch(goToPrevStep());
  };

  return (
    <NewReviewModalFooter
      next={
        <Button data-testid="nextstep" fullWidth={isMobile} size="M" onClick={handleNextClick} loading={isLoading}>
          {nextButtonText || 'Дальше'}
        </Button>
      }
      prev={
        isPrevStepAvailable ? (
          <Button
            data-testid="prevstep"
            fullWidth={isMobile}
            size="M"
            theme={isMobile ? 'fill_secondary' : 'fill_white_primary'}
            onClick={onPrevClick}
            disabled={isLoading}
          >
            Назад
          </Button>
        ) : null
      }
    />
  );
};
